import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

import { withRouter } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { compose } from "redux";
import CouponList from "./CouponList";
import CouponForm from "./CouponForm";

import { ADD_NEW } from "constants/commonConstants";

import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import couponReducer from "store/CouponDetail/reducer";
import couponSaga from "store/CouponDetail/saga";
import productCategoryReducer from "store/Masters/ProductCategory/reducer";
import productCategorySaga from "store/Masters/ProductCategory/saga";

const couponKey = "CouponDetail";
const productCategoryKey = "ProductCategoryMaster";

const withCouponReducer = injectReducer({
  key: couponKey,
  reducer: couponReducer,
});
const withCouponSaga = injectSaga({ key: couponKey, saga: couponSaga });

const withProductCategoryReducer = injectReducer({
  key: productCategoryKey,
  reducer: productCategoryReducer,
});
const withProductCategorySaga = injectSaga({
  key: productCategoryKey,
  saga: productCategorySaga,
});

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formDialog: false,
      couponData: null,
    };

    this.validator = new SimpleReactValidator();
  }

  onCouponInsertUpdateSuccess = () => {
    this.setState({
      formDialog: false,
      couponData: null,
    });
  };

  viewCoupon = (coupon) => {
    this.setState({
      formDialog: true,
      couponData: coupon,
    });
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid className="pt-4">
          <CouponForm
            formDialog={this.state.formDialog}
            couponRecord={this.state.couponData}
            closeModal={() => this.onCouponInsertUpdateSuccess()}
          ></CouponForm>

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between">
                    <h4 className="mt-0 page-title">Coupon</h4>
                    <button
                      className="btn btn-primary waves-effect waves-light float-right"
                      onClick={() => this.viewCoupon(null)}
                    >
                      {ADD_NEW}
                    </button>
                  </div>

                  <CouponList
                    onViewCoupon={(couponValues) =>
                      this.viewCoupon(couponValues)
                    }
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default compose(
  withCouponReducer,
  withCouponSaga,
  withProductCategoryReducer,
  withProductCategorySaga,
  withRouter
)(Index);
//export default withRouter(withConnect)(Index);
